<template>
  <ValidationObserver ref="customerForm" v-slot="{ invalid, passes }">
    <v-skeleton-loader :loading="loading" :types="skeleton" type="article, actions" class="mb-6">
      <v-form rel="customerForm" @submit.prevent="passes(save)">
        <v-card class="elevation-1 mb-6 rounded-lg">
          <v-card-title class="pa-7">
            {{ title }}
          </v-card-title>
          <v-card-text class="pl-7 pr-7 pt-7">
            <v-row>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VAutocompleteWithValidation
                  v-model.trim="value.genderName"
                  label="Oslovení"
                  outlined
                  dense
                  background-color="white"
                  :items="genders"
                  item-text="text"
                  item-value="name"
                  :loading="gendersLoading"
                  :clearable="true"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VTextFieldWithValidation
                  v-model="value.name"
                  rules="required"
                  outlined
                  dense
                  label="Jméno"
                  data-cy="name"
                />
              </v-col>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VTextFieldWithValidation
                  v-model="value.surname"
                  rules="required"
                  outlined
                  dense
                  label="Příjmení"
                  data-cy="surname"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VTextFieldWithValidation
                  v-model="value.titleBefore"
                  outlined
                  dense
                  label="Titul před"
                  data-cy="titleBefore"
                />
              </v-col>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VTextFieldWithValidation
                  v-model="value.titleAfter"
                  outlined
                  dense
                  label="Titul za"
                  data-cy="titleAfter"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VDatePickerEditableWithValidation
                  v-model="value.birthday"
                  date-format="dd.MM.yyyy"
                  outlined
                  dense
                  label="Datum narození"
                  data-cy="phone"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VTextFieldWithValidation
                  v-model="value.phone"
                  rules="required|phone"
                  outlined
                  dense
                  label="Telefon (ve formátu +420123456789)"
                  data-cy="phone"
                />
              </v-col>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VTextFieldWithValidation
                  v-model="value.email"
                  rules="email"
                  outlined
                  dense
                  label="E-mail"
                  data-cy="email"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VTextFieldWithValidation
                  v-model.trim="value.bankAccountNumber"
                  label="Číslo bankovního účtu"
                  type="number"
                  outlined
                  dense
                  background-color="white"
                />
              </v-col>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VTextFieldWithValidation
                  v-model.trim="value.bankCode"
                  label="Kód banky"
                  type="number"
                  outlined
                  dense
                  background-color="white"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VTextFieldWithValidation
                  v-model.trim="value.sipoNumber"
                  label="Číslo SIPO"
                  type="number"
                  outlined
                  dense
                  background-color="white"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pa-7">
            <v-spacer></v-spacer>
            <v-btn
              type="submit"
              height="40px"
              min-width="130px"
              color="primary"
              depressed
              :loading="saving"
            >
              Uložit
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-skeleton-loader>
  </ValidationObserver>
</template>

<script>
import VDatePickerEditableWithValidation from '@/components/validators/VDatePickerEditableWithValidation'
import { mapActions } from 'vuex'
import VAutocompleteWithValidation from '../validators/VAutocompleteWithValidation.vue'
export default {
  name: 'CustomerForm',
  components: {
    VAutocompleteWithValidation,
    VDatePickerEditableWithValidation,
  },
  props: {
    value: {
      type: Object,
    },
    title: {
      type: String,
      default: '',
    },
    edit: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
      required: false,
    },
    saving: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      skeleton: {
        article: 'heading, paragraph@2',
      },
      genders: [],
      gendersLoading: false,
    }
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        if (this.value.gender) {
          this.value.genderName = this.value.gender.name
        }
      },
    },
  },
  created() {
    this.loadCustomerGenders()
  },
  methods: {
    ...mapActions({
      listCustomerGender: 'enum/listCustomerGender',
    }),
    loadCustomerGenders() {
      this.gendersLoading = true
      this.listCustomerGender()
        .then((response) => {
          this.genders = response.data
        })
        .finally(() => {
          this.gendersLoading = false
        })
    },
    save() {
      this.$emit('save', this.value)
    },
  },
}
</script>
